import { defineMessages } from 'react-intl';

export default defineMessages({
  modalTitle: {
    id: 'amountCurrency.modal.title',
    defaultMessage: 'Select your currency',
  },
});
